module.exports = __webpack_public_path__ + "public/images/triangular-background-pattern.ed1cf79ee5f38a59563b5658bbe3f4e7.svg";